import { InjectionKey } from 'vue'
import { createStore, useStore as baseUseStore, Store } from 'vuex'
import { RootStateTypes } from '@/store/interface/index'

const files = require.context('./modules', false, /\.ts$/)
const modules = {}
files.keys().forEach((key) => {
  if (key === './index.ts') { return }
  modules[key.replace(/(\.\/|\.ts)/g, '')] = files(key).default
})

// eslint-disable-next-line symbol-description
export const key: InjectionKey<Store<RootStateTypes>> = Symbol()

export const store = createStore<RootStateTypes>({ modules })

export function useStore () {
  return baseUseStore(key)
}
